<template>
  <div class="card-wrapper reasons-page-wrap">
    <ReasonsHeader />
    <div class="reasons-page container">
      <div class="row">
        <div class="page-introduction">
          <h4 class="page-introduction_title">A sustained reform program</h4>
          <span class="page-introduction_subtitle"
            >to improve the business climate</span
          >
          <p class="page-introduction_description">
            In order to improve its investment climate, develop its
            attractiveness for FDI and ensure its strong integration into the
            global economy, Gabon has accelerated the implementation of multiple
            and varied reforms in recent years.
          </p>
          <a
            href="https://a.storyblok.com/f/43998/x/92e81d5d28/reasons-to-invest-in-gabon-all.pdf"
            target="_blank"
            class="page-introduction_link"
            >Download full PDF</a
          >
        </div>
        <div class="page-content">
          <h3>Key reforms that facilitate business practice</h3>

          <section class="section-odd">
            <div class="section-header">
              <span class="section-num">1</span>
              <span class="section-title"
                >Promotion and facilitation of private investment with the
                creation of the National Agency for Investment Promotion
                (ANPI-Gabon)</span
              >
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    ANPI-Gabon is the host, information and support platform for
                    any investor ready to set up in the country
                  </li>
                  <li>
                    The government institution supports domestic and
                    international investors in the creation of businesses,
                    facilitating the procedures of obtaining approvals and
                    authorizations.
                  </li>
                </ul>
                <p>
                  <a href="https://investingabon.ga" target="_blank"
                    >https://investingabon.ga</a
                  >
                </p>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-1.png" />
              </div>
            </div>
          </section>

          <section class="section-even">
            <div class="section-header">
              <span class="section-num">2</span>
              <span class="section-title"
                >Promotion and support of public-private dialogue with the
                establishment of the High Council for Investment (HCI)</span
              >
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    HCI is the platform for direct dialogue and strategic
                    thinking between the Government and the private sector.
                  </li>
                  <li>
                    The platform intervenes on all issues related to the
                    business environment and the modalities of development of
                    private investments.
                  </li>
                </ul>
                <p>
                  <a href="https://investingabon.ga" target="_blank"
                    >https://investingabon.ga</a
                  >
                </p>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-2.png" />
              </div>
            </div>
          </section>

          <section class="section-odd">
            <div class="section-header">
              <span class="section-num">3</span>
              <span class="section-title"
                >Digitalisation of the business creation procedure in order to
                comply with international standards</span
              >
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    In 2020, ANPI-Gabon launched the Digital Investment Window
                    (GNI), the only online business creation platform in the
                    sub-region.
                  </li>
                  <li>
                    By connecting to the GNI, the investor can create his
                    company in less than 48 hours at advantageous rates
                    regardless of his country of residence
                  </li>
                </ul>
                <p>
                  <a href="https://investingabon.ga" target="_blank"
                    >https://investingabon.ga</a
                  >
                </p>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-3.png" />
              </div>
            </div>
          </section>

          <section class="section-even">
            <div class="section-header">
              <span class="section-num">4</span>
              <span class="section-title"
                >Improving trade justice to restore investor confidence</span
              >
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    By the law of 5 July 2019, Gabon has set up the Commercial
                    Court of Libreville, the first in Central Africa for the
                    efficient and rapid settlement of disputes
                  </li>
                  <li>
                    The country also has an International Institute of
                    Mediation, Arbitration and Conciliation (IIMAC) to ensure
                    amicable settlement of commercial disputes.
                  </li>
                </ul>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-4.png" />
              </div>
            </div>
          </section>

          <section class="section-odd">
            <div class="section-header">
              <span class="section-num">5</span>
              <span class="section-title"
                >Signing of pro-foreign investment protection agreements</span
              >
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    Gabon has signed several international treaties and
                    agreements on investment and taxation with several partner
                    countries around the world (India, Singapore, Morocco,
                    etc.).
                  </li>
                  <li>
                    These agreements are characterized by the absence of
                    restrictions or limitations for foreign investors concerning
                    the double taxation, conversion, transfer or repatriation of
                    funds associated with an investment in Gabon
                  </li>
                </ul>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-5.png" />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReasonsHeader from "./reasons-header.vue";

export default {
  name: "reasons-1",
  components: { ReasonsHeader },
};
</script>

<style scoped lang="scss" src="./reasons.scss"></style>
